import React from 'react';

// NOTE: The component is still exported as `ScrollingTicker` so existing imports
// in HomePage continue to work, but it now renders a static, honest, accessible
// icon-based trust bar — no motion, no unverifiable claims.

const TRUST_ITEMS = [
  {
    label: 'Ships Nationwide',
    sub: 'Across the USA · 2–5 days',
    icon: (
      <svg
        className="w-5 h-5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        strokeWidth={1.75}
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M3 17V7a1 1 0 011-1h10v11M14 11h4l3 3v3h-7M7 20a2 2 0 110-4 2 2 0 010 4zm10 0a2 2 0 110-4 2 2 0 010 4z"
        />
      </svg>
    ),
  },
  {
    label: 'Verified Formulas',
    sub: 'Small-batch · ingredient-checked',
    icon: (
      <svg
        className="w-5 h-5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        strokeWidth={1.75}
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    ),
  },
  {
    label: 'Easy Returns',
    sub: '30 days · no questions',
    icon: (
      <svg
        className="w-5 h-5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        strokeWidth={1.75}
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9 14l-4-4 4-4M5 10h8a6 6 0 010 12h-2"
        />
      </svg>
    ),
  },
  {
    label: 'Real Support',
    sub: 'WhatsApp & email replies',
    icon: (
      <svg
        className="w-5 h-5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        strokeWidth={1.75}
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
        />
      </svg>
    ),
  },
];

const ScrollingTicker = ({ label, centerContent }) => {
  return (
    <div
      className="hidden md:block w-full bg-gray-900/60 border-y border-amber-400/15 py-2"
      role="region"
      aria-label="Shopping benefits"
    >
      <div className="container mx-auto px-4 flex items-center gap-4">
        {label && (
          <p className="text-amber-300/80 uppercase tracking-[0.2em] text-xs font-medium shrink-0">
            {label}
          </p>
        )}
        {centerContent && (
          <div className="flex-1 min-w-0 flex justify-center">{centerContent}</div>
        )}
        <ul className="flex items-center gap-6 list-none shrink-0 ml-auto">
          {TRUST_ITEMS.map((item) => (
            <li key={item.label} className="relative group">
              {/* Icon */}
              <span
                className="text-amber-400/60 hover:text-amber-400 transition-colors duration-200 block cursor-default"
                aria-label={`${item.label}: ${item.sub}`}
              >
                {item.icon}
              </span>

              {/* Tooltip — appears above on hover */}
              <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2.5 pointer-events-none opacity-0 group-hover:opacity-100 transition-all duration-200 group-hover:-translate-y-0.5 translate-y-1 z-50">
                <div className="bg-gray-900 border border-amber-400/30 rounded-lg px-3 py-2 shadow-xl shadow-black/40 text-center whitespace-nowrap">
                  <p className="text-[11px] font-bold uppercase tracking-wider text-amber-300">{item.label}</p>
                  {item.sub && <p className="text-[10px] text-gray-400 mt-0.5">{item.sub}</p>}
                </div>
                {/* Arrow */}
                <div className="absolute top-full left-1/2 -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-amber-400/30" />
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};


export default ScrollingTicker;
